// extracted by mini-css-extract-plugin
export default {"customNavTabs":"escrowView_customNavTabs__JB+WM","tabItem":"escrowView_tabItem__LUv-N","active":"escrowView_active__cmwkY","tabSeparator":"escrowView_tabSeparator__FABRa"};